import { CustomObjectTypeEnum } from '../enums/customObjectType.enum';

export class CustomObject {
    id?: string;
    name: string;
    type: CustomObjectTypeEnum;
    typeName: string;
    icon: string;
}

